export enum APPS {
  WELL_GUARDIAN = 'WELL_GUARDIAN',
}

export enum APP_MODULES {
  // HOME
  HOME = 'HOME',
  // WELL GUARDIAN
  WELL_GUARDIAN = 'WELL_GUARDIAN',
}
